// Module
var code = "<div class=bible> <div class=bibletext> <p> <span class=cwvnum>5</span>&nbsp;&nbsp;Let them be put to shame and turned backwards,&nbsp;<span class=redlight>&#149;</span><br/>&nbsp;&nbsp;&nbsp;as many as are enemies of Zion.<br> </p> </div></div>";
// Exports
module.exports = code;